export default __webpack_public_path__ + "static/media/final02.4023c4ea.gif";